/**
 * Toggle platform + module sidebars for full-width report viewing.
 */
export default function AdminPumpHubFocusBar({
  platformNavVisible,
  hubNavVisible,
  onTogglePlatformNav,
  onToggleHubNav,
  activeModuleLabel = '',
}) {
  return (
    <div className="admin-pump-hub__focus-bar">
      <div className="admin-pump-hub__focus-bar-inner">
        <span className="admin-pump-hub__focus-label">
          {activeModuleLabel ? `Viewing: ${activeModuleLabel}` : 'Pump command center'}
        </span>
        <div className="admin-pump-hub__focus-actions">
          <button
            type="button"
            className={`admin-pump-hub__focus-toggle ${platformNavVisible ? 'is-active' : ''}`}
            onClick={onTogglePlatformNav}
            aria-pressed={platformNavVisible}
            title={platformNavVisible ? 'Hide platform sidebar menu' : 'Show platform sidebar menu'}
          >
            {platformNavVisible ? 'Menu on' : 'Menu'}
          </button>
          <button
            type="button"
            className={`admin-pump-hub__focus-toggle ${hubNavVisible ? 'is-active' : ''}`}
            onClick={onToggleHubNav}
            aria-pressed={hubNavVisible}
            title={hubNavVisible ? 'Hide module navigation' : 'Show module navigation'}
          >
            {hubNavVisible ? 'Modules on' : 'Modules'}
          </button>
          {!platformNavVisible && !hubNavVisible && (
            <span className="admin-pump-hub__focus-badge">Full width</span>
          )}
        </div>
      </div>
    </div>
  );
}
